import React from 'react';
import { useTranslation } from 'react-i18next';
import './OrderTracker.css';

const STEPS = [
  { key: 'pending', icon: 'receipt_long' },
  { key: 'preparing', icon: 'restaurant' },
  { key: 'ready', icon: 'check_circle' },
  { key: 'delivered', icon: 'delivery_dining' }
];

const STATUS_ORDER = ['pending', 'preparing', 'ready', 'delivered'];

function OrderTracker({ status }) {
  const { t } = useTranslation();

  const currentIndex = STATUS_ORDER.indexOf(status);
  const progressPercent = currentIndex >= 0 ? (currentIndex / (STEPS.length - 1)) * 100 : 0;

  const getStepState = (stepIndex) => {
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'active';
    return 'pending';
  };

  return (
    <div className="order-tracker">
      <div className="order-tracker-progress">
        <div
          className="order-tracker-progress-bar"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <div className="order-tracker-steps">
        {STEPS.map((step, index) => {
          const state = getStepState(index);
          return (
            <div
              key={step.key}
              className={`order-tracker-step order-tracker-step--${state}`}
            >
              <div className="order-tracker-step-icon">
                <span className="material-icons" aria-hidden="true">{step.icon}</span>
                {state === 'completed' && (
                  <span className="order-tracker-check material-icons">check</span>
                )}
              </div>
              <span className="order-tracker-step-label">
                {t(`orders.${step.key}`)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OrderTracker;
